var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0213 11.0209C10.7567 11.0209 10.5422 11.2355 10.5422 11.5001C10.5422 11.7647 10.7567 11.9792 11.0213 11.9792H16.7713C17.0359 11.9792 17.2505 11.7647 17.2505 11.5001C17.2505 11.2355 17.0359 11.0209 16.7713 11.0209H11.0213Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5422 9.58342C10.5422 9.31878 10.7567 9.10425 11.0213 9.10425H15.813C16.0776 9.10425 16.2922 9.31878 16.2922 9.58342C16.2922 9.84801 16.0776 10.0626 15.813 10.0626H11.0213C10.7567 10.0626 10.5422 9.84801 10.5422 9.58342Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9797 12.9376C11.7151 12.9376 11.5005 13.1522 11.5005 13.4167C11.5005 13.6813 11.7151 13.8959 11.9797 13.8959H16.7713C17.0359 13.8959 17.2505 13.6813 17.2505 13.4167C17.2505 13.1522 17.0359 12.9376 16.7713 12.9376H11.9797Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9814 4.79175H6.89377C6.4943 4.79175 6.13672 5.03954 5.99645 5.41359L2.4027 14.9969C2.16777 15.6234 2.63091 16.2917 3.30002 16.2917H8.62548L8.90763 17.4728C9.01068 17.9041 9.39624 18.2084 9.83977 18.2084H19.8564C20.246 18.2084 20.5709 17.9796 20.7228 17.6602C20.8139 17.4686 20.8429 17.2444 20.7861 17.0177L17.9111 5.51765C17.9027 5.48408 17.8926 5.4513 17.881 5.41939C17.8368 5.29923 17.77 5.19144 17.686 5.10049C17.509 4.90865 17.2562 4.79175 16.9814 4.79175ZM6.60182 6.52862L8.48856 15.3334H3.30002L6.60182 6.52862ZM16.9814 5.75008H7.41507L9.87935 17.2501H19.8564L16.9814 5.75008Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.879b75433dd539a09a523e5200f8291a.svg";
export { ForwardRef as ReactComponent };